import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { PolicyNote } from "@covertree/agent-portal-graphql";
import { NoteCard } from "@covertree/ui";

interface NotesListProps {
  notes: PolicyNote[];
}

export function NotesList({ notes }: NotesListProps) {
  return notes.length > 0 ? (
    notes.map((note) => (
      <NoteCard {...note} key={`${note.createdDate}_${note.authorId}`} />
    ))
  ) : (
    <Grid
      item
      xs={12}
      p={3}
      borderRadius={1}
      mb={2}
      bgcolor="secondary.contrastText">
      <Typography align="center">
        This policy does not have any notes yet
      </Typography>
    </Grid>
  );
}
